import { TabIdList } from 'components/tab-list/tab-list.enums';

export enum SectionContentLinkListIdOne {
  RegistrationInformation = `${TabIdList.DataCollection}--registration-information`,
  LinkedSocialMediaInformation = `${TabIdList.DataCollection}--linked-social-media-information`,
  ProfileVerificationInformation = `${TabIdList.DataCollection}--profile-verification-information`,
  PurchaseInformation = `${TabIdList.DataCollection}--purchase-information`,
  GeolocationInformation = `${TabIdList.DataCollection}--geolocation-information`,
  DeviceInformation = `${TabIdList.DataCollection}--device-information`,
  PhotoInformation = `${TabIdList.DataCollection}--photo-information`,
  LinkInformation = `${TabIdList.DataCollection}--link-information`,
  Messages = `${TabIdList.DataCollection}--messages`,
  BumbleSuccessStories = `${TabIdList.DataCollection}--bumble-success-stories`,
  CustomerSupportContactInformation = `${TabIdList.DataCollection}--customer-support-contact-information`,
  CookiesAndSimilarTechnologyInformation = `${TabIdList.DataCollection}--cookies-and-similar-technology-information`,
}

/** include TabIdList value with -- it helps to make ids unique */
export enum SectionContentLinkListIdTwo {
  UsingYourInformation = `${TabIdList.InformationUsage}--using-your-information`,
  OurMatchingAlgorithms = `${TabIdList.InformationUsage}--our-matching-algorithms`,
  ModerationPractices = `${TabIdList.InformationUsage}--moderation-practices`,
  LawfulBasis = `${TabIdList.InformationUsage}--lawful-basis`,
  BeePitched = `${TabIdList.InformationUsage}--bee-pitched`,
  ConnectionQuizzes = `${TabIdList.InformationUsage}--connection-quizzes`,
}

export enum SectionContentLinkListIdThree {
  ThingsToKeepInMind = `${TabIdList.InformationDisclosure}--things-to-keep-in-mind`,
  BFFProfileSharing = `${TabIdList.InformationDisclosure}--bff-profile-sharing`,
}

export enum SectionContentLinkListIdFour {
  OurCommitmentsToYou = `${TabIdList.InformationSharing}--our-commitments-to-you`,
}

export enum SectionContentLinkListIdFive {
  RightToBeInformed = `${TabIdList.Rights}--right-to-be-informed`,
  RightToAccess = `${TabIdList.Rights}--right-to-access`,
  RightToRectify = `${TabIdList.Rights}--right-to-rectify`,
  RightToDataPortability = `${TabIdList.Rights}--right-to-data-portability`,
  RightToErase = `${TabIdList.Rights}--right-to-erase`,
  RightToRestrictOrObject = `${TabIdList.Rights}--right-to-restrict-or-object`,
  RightToComplain = `${TabIdList.Rights}--right-to-complain`,
  RightsRelatedToAutomatedDecisionMaking = `${TabIdList.Rights}--rights-related-to-automated-decision-making`,
  HowDoYouEnforceYourRights = `${TabIdList.Rights}--how-do-you-enforce-your-rights`,
  DoYouLiveInCalifornia = `${TabIdList.Rights}--do-you-live-in-california`,
}

export enum SectionContentLinkListIdSix {
  WhatHappensWhenYouDeleteYourAccount = `${TabIdList.InformationStoring}--what-happens-when-you-delete-your-account`,
  ConnectingYouAroundTheWorld = `${TabIdList.InformationStoring}--connecting-you-around-the-world`,
}

export enum SectionContentLinkListIdSeven {
  TipsToKeepYourDataSecure = `${TabIdList.SecurityAndAge}--tips-to-keep-your-data-secure`,
  AgeRestrictionPolicy = `${TabIdList.SecurityAndAge}--age-restriction-policy`,
}

export enum SectionContentLinkListIdEight {
  OurContactInformation = `${TabIdList.ContactUs}--our-contact-information`,
}

export enum SectionContentLinkListIdNine {
  California = `${TabIdList.UsResidents}--california`,
  Colorado = `${TabIdList.UsResidents}--colorado`,
  Connecticut = `${TabIdList.UsResidents}--connecticut`,
  NewJersey = `${TabIdList.UsResidents}--new-jersey`,
  Oregon = `${TabIdList.UsResidents}--oregon`,
  Texas = `${TabIdList.UsResidents}--texas`,
  Utah = `${TabIdList.UsResidents}--utah`,
  Virginia = `${TabIdList.UsResidents}--virginia`,
}
